/* eslint-disable max-len */
import 'react';

const InfoSvg = (props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g fill="none" fillRule="evenodd">
            <circle fill="#37F" cx="8" cy="8" r="8" />
            <path
                d="M8 5.333a.889.889 0 110-1.777.889.889 0 010 1.777zm0 7.111a.889.889 0 01-.889-.888V7.11a.889.889 0 111.778 0v4.445c0 .49-.398.888-.889.888z"
                fill="#FFF"
            />
        </g>
    </svg>
);
export default InfoSvg;
